import { jsx as e } from "react/jsx-runtime";
import { Responsive as p } from "@instructure/ui-responsive";
const r = {
  miniTablet: { minWidth: "500px" },
  tablet: { minWidth: "768px" },
  desktop: { minWidth: "992px" },
  desktopNavOpen: { minWidth: "1140px" },
  desktopOnly: { minWidth: "768px" },
  mobileOnly: { maxWidth: "767px" },
  ICEDesktop: { minWidth: "1025px" }
}, m = (t) => {
  const n = {};
  for (const o of t || [])
    n[o] = !0;
  return n;
};
function h(t) {
  return (o) => /* @__PURE__ */ e(
    p,
    {
      match: "media",
      query: r,
      render: (d, i) => /* @__PURE__ */ e(t, { breakpoints: m(i), ...o })
    }
  );
}
export {
  r as BREAKPOINTS,
  h as WithBreakpoints
};
